import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { useFormField } from '../hooks/useFormField';

interface SelectOption {
  value: string;
  label: string;
}

interface FormSelectProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  id?: string;
  label?: string;
  required?: boolean;
  options: SelectOption[];
  placeholder?: string;
  className?: string;
  error?: string;
}

function FormSelect<T extends FieldValues>({ 
  name, 
  control, 
  id,
  label,
  required,
  options,
  placeholder = "Selecione...",
  className = "",
  ...selectProps 
}: FormSelectProps<T>) {
  const { value, onChange, onBlur, error } = useFormField({ name, control });

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor={id}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        {...selectProps}
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
          error ? 'border-red-300' : 'border-gray-300'
        } ${className}`}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}

export default FormSelect;